<template>
  <div class="login" :style="{justifyContent: !isMaoming?'space-between':'center'}">
    <div v-if="!isMaoming" class="login-top">
      <div class="top-content">
        <div class="top-left">
          <img :src="logoImg" alt="宏兔兔课后托管">
          <span>宏兔兔课后托管</span>
        </div>
        <div class="top-right">
          <img :src="addImg" alt="服务商入驻">
          <a
            href="https://cloud.gzhtedu.cn/#/eduInstitutionSettle?modal=1&applyType=2"
            target="_blank"
          >服务商入驻</a>
        </div>
      </div>
    </div>
    <div class="login-content">
      <div class="content-left">
        <img :src="contentImg" alt="">
      </div>
      <div class="content-right">
        <div class="content-top">
          <div class="top-item" :class="tab==='2'?'top-item-active':''" @click="handleChangeTab('2','formInfo')">短信登录</div>
          <div class="top-item" :class="tab==='1'?'top-item-active':''" @click="handleChangeTab('1','formPhoneInfo')">账号登录</div>
        </div>
        <div class="content-info">
          <div v-show="tab==='2'" class="tab-content">
            <Form
              ref="formPhoneInfo"
              :model="formPhoneInfo"
              :rules="rulePhoneInfo"
              :label-width="0"
            >
              <FormItem prop="phone">
                <div class="phone">
                  <Input
                    v-model="formPhoneInfo.phone"
                    size="large"
                    placeholder="请输入手机号码"
                    style="width: 100%"
                    clearable
                    @on-keypress.enter="handleSubmit('formPhoneInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="
                        formPhoneInfo.phone
                          ? 'usernameIcon active'
                          : 'usernameIcon'
                      "
                    ></span> -->
                  </Input>
                </div>
              </FormItem>
              <FormItem prop="code">
                <div class="code">
                  <Input
                    v-model="formPhoneInfo.code"
                    size="large"
                    placeholder="请输入验证码"

                    @on-keypress.enter="handleSubmit('formInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="
                        formPhoneInfo.code ? 'codeIcon active' : 'codeIcon'
                      "
                    ></span> -->
                  </Input>
                  <div class="img-code" @click="getImageCodeFunc">
                    <img :src="imgUrl" class="img100">
                  </div>
                  <!-- <img :src="imgUrl" class="img-code" @click="getImgCode" /> -->
                </div>
              </FormItem>
              <FormItem prop="msgCode">
                <div class="code msgCode">
                  <Input
                    v-model="formPhoneInfo.msgCode"
                    size="large"
                    placeholder="请输入短信验证码"
                    @on-keypress.enter="handleSubmit('formPhoneInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="
                        formPhoneInfo.msgCode ? 'codeIcon active' : 'codeIcon'
                      "
                    ></span> -->
                  </Input>
                  <div
                    class="msg-code"
                    :class="{ gray: codeText != '获取验证码' }"
                    @click="getCodeFunc"
                  >
                    {{ codeText }}
                  </div>
                  <!-- <img :src="imgUrl" class="img-code" @click="getImgCode" /> -->
                </div>
              </FormItem>
            </Form>
          </div>
          <div v-show="tab==='1'" class="tab-content">
            <Form
              ref="formInfo"
              :model="formInfo"
              :rules="ruleInfo"
              :label-width="0"
            >
              <FormItem prop="username">
                <div class="username">
                  <Input
                    v-model="formInfo.username"
                    size="large"
                    placeholder="请输入账号"
                    type="text"
                    style="width: 100%"
                    clearable
                    @on-keypress.enter="handleSubmit('formInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="
                        formInfo.username
                          ? 'usernameIcon active'
                          : 'usernameIcon'
                      "
                    ></span> -->
                  </Input>
                </div>
              </FormItem>
              <FormItem prop="password">
                <div class="password">
                  <Input
                    v-model="formInfo.password"
                    type="password"
                    size="large"
                    placeholder="请输入密码"
                    style="width: 100%"
                    clearable
                    @on-keypress.enter="handleSubmit('formInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="
                        formInfo.password
                          ? 'passwordIcon active'
                          : 'passwordIcon'
                      "
                    ></span> -->
                  </Input>
                </div>
              </FormItem>
              <FormItem prop="code">
                <div class="code">
                  <Input
                    v-model="formInfo.code"
                    size="large"
                    placeholder="请输入验证码"
                    @on-keypress.enter="handleSubmit('formInfo')"
                  >
                    <!-- <span
                      slot="prefix"
                      :class="formInfo.code ? 'codeIcon active' : 'codeIcon'"
                    ></span> -->
                  </Input>
                  <div class="img-code" @click="getImageCodeFunc">
                    <img :src="imgUrl" class="img100">
                  </div>
                  <!-- <img :src="imgUrl" class="img-code" @click="getImgCode" /> -->
                </div>
              </FormItem>
            </Form>
          </div>
          <div class="btn-block">
            <Button
              class="btn"
              type="primary"
              style="width:100%"
              :loading="loginLoading"
              @click="handleSubmit()"
            >登录</Button>
          </div>
          <div v-if="!isMaoming" class="agreement">
            <span>登录即视为同意</span>
            <!-- <a
              href="https://kh.gzhtedu.cn/430aggrement/user-agreement.html"
              target="_blank"
            >《用户协议》</a> -->
            <span class="document-dot" @click="handleToDocument('MP_PARENT_USER_PROTOCOL')">《用户协议》</span>
            <span>和</span>
            <span class="document-dot" @click="handleToDocument('MP_PARENT_USER_PRIVACY')">《隐私政策》</span>
            <!-- <a
              href="https://kh.gzhtedu.cn/430aggrement/privacy-agreement.html"
              target="_blank"
            >《隐私政策》</a> -->
          </div>
        </div>

      </div>
    </div>
    <div v-if="!isMaoming" class="filings">
      <div class="filings-top">
        Copyright@2015 - {{ nowYear }} 广州宏途数字科技有限公司 All Rights Reserved
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/"
        >粤ICP备15058200号-2</a>
      </div>
      <div class="filings-bottom">服务热线: 400-100-0233</div>
    </div>
  </div>
</template>

<script>
import { decrypt } from '@/utils/encry';
import Cookies from 'js-cookie';
// import { encode } from 'js-base64';
import loginApi from '@/request/login/index.js';
import { isPhone } from '@/utils/utils';
import common from '@/request/common/index';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';

export default {
  name: 'LoginPage',
  data() {
    const validatePhoneCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!isPhone(value)) {
        callback(new Error('请输入正确的11位手机号'));
      } else {
        callback();
      }
    };
    return {
      logoImg: require('@assets/img/login/logo@2x.png'),
      addImg: require('@assets/img/login/icon_enter@2x.png'),
      contentImg: require('@assets/img/login/img_illustrations@2x.png'),
      baseUrl: process.env.BASE_URL,
      imgUrl: '',
      captchaKey: '',
      singlePoint: false, // 是否单点登录
      codesingle: '', // 单点登录code
      tab: '1',
      formInfo: {
        username: '',
        password: '',
        code: '',
        phone: ''
      },
      formPhoneInfo: {
        msgCode: '',
        code: '',
        phone: ''
      },
      ruleInfo: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      rulePhoneInfo: {
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        msgCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
        phone: [{ validator: validatePhoneCheck, required: true, trigger: 'blur' }]
      },
      secondary: false,
      formSecond: {
        phone: '',
        phoneCode: ''
      },
      countdown: 60, // 倒计时
      countInterval: null, // 倒计时计时器
      portOrg: '0',
      codeText: '获取验证码',

      timer: null,
      loginLoading: false,
      nowYear: ''
    };
  },
  computed: {
    ...mapState(['isMaoming']),
    ...mapGetters(['adminIdentityInfo', 'adminIdentityIndex'])
  },
  created() {
    // 用户身份标识  admin-管理员 org-机构(服务) school-学校 parent-家长 edu-教育局

    // this.tab = localStorage.getItem('loginTab') ? localStorage.getItem('loginTab') : '2';
    this.tab == '2' ? this.formPhoneInfo.phone = localStorage.getItem('loginUserName') : this.formInfo.username = localStorage.getItem('loginUserName');
    this.getImageCodeFunc();
    this.getNowYear();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations([
      'SET_ADMINIDENTITY',
      'SET_ADMINIDENTITYINDEX',
      'SET_THEUSERIDENTITY',
      'SET_ROUTELIST',
      'CLOSE_BROWSINGHISTORYLIST',
      'SET_AUTH_MAP',
      'SET_CACHEROUTE'
    ]),
    ...mapActions('orderCenter', [
      'udpateSettlementSearchByAction',
      'updateSettlementDetailsSearch'
    ]),
    handleToDocument(type) {
      const { href } = this.$router.resolve({
        name: 'passport_document',
        query: {
          type
        }
      });
      window.open(href);
      // this.$router.push({
      //   name: 'passport_document',
      //   query: {
      //     type
      //   }
      // });
    },
    handleChangeTab(tab, name) {
      if (this.loginLoading) {
        return;
      }
      this.$refs[name].resetFields();
      this.$nextTick(() => {
        this.tab = tab;
      });
    },
    getNowYear() {
      this.nowYear = new Date().getFullYear();
    },
    handleSubmit() {
      const name = this.tab == '1' ? 'formInfo' : 'formPhoneInfo';
      console.log(name);
      this.$refs[name].validate(valid => {
        console.log(valid);
        if (valid) {
          if (this.tab == 1) {
            this.doLogin();
          } else {
            this.phoneCodeToPcLogin();
          }
        }
      });
    },
    secondSubmitHandel() {
      if (!this.verificationSecond()) return;
      this.secondLogin();
    },
    verificationSecond() {
      let status = true;
      if (!/^1[3456789]\d{9}$/.test(this.formSecond.phone)) {
        status = false;
        this.$Message.warning('请填写正确手机号！');
        return status;
      }
      if (!this.formSecond.phoneCode) {
        status = false;
        this.$Message.warning('请填写短信二维码！');
        return status;
      }
      return status;
    },
    // todo 验证码倒计时
    getCode() {
      --this.countdown;
      this.countInterval = setInterval(() => {
        --this.countdown;
        if (this.countdown === 0) {
          this.countdown = 60;
          clearInterval(this.countInterval);
        }
      }, 1000);
    },
    // 忘记密码
    handleForgetPwd() {
      this.$Message.info({
        content: '请联系管理员'
      });
    },
    async handleSetLoginInfo(res) {
      if (res.status === 200 && res.message.sysAdminDTOList && res.message.sysAdminDTOList.length > 0) {
        localStorage.setItem('loginUserName', this.tab == 2 ? this.formPhoneInfo.phone : this.formInfo.username);
        localStorage.setItem('loginTab', this.tab);
        this.SET_ROUTELIST([]);
        let index = res.message.sysAdminDTOList.findIndex(item => {
          return item.userId === res.message.lastUserId;
        });
        index = index === -1 ? 0 : index;
        this.SET_ADMINIDENTITY(res.message.sysAdminDTOList);
        this.SET_ADMINIDENTITYINDEX(index);
        this.SET_CACHEROUTE([]);
        // 用户身份标识  admin-管理员 org-机构(服务) school-学校 parent-家长 edu-教育局
        const theUserIdentity = res.message.sysAdminDTOList[index].userIdentity;

        switch (theUserIdentity) {
          // 运营平台
          case 'admin':
            this.portOrg = '0';

            break;
          // 教育局
          case 'edu':
            this.portOrg = '1';
            break;
          // 学校
          case 'school':
            this.portOrg = '2';

            break;
          // 机构(服务)
          case 'org':
            this.portOrg = '3';
            break;
        }
        this.SET_THEUSERIDENTITY(res.message.sysAdminDTOList[index].userIdentity);
        this.userId = this.adminIdentityInfo.userId;
        const paramsTrue = {
          loginCredential: res.message.loginCredential,
          userId: this.adminIdentityInfo.userId,
          namespace: 'zhxybasic',
          key: '430-login'
        };
        this.loginLoading = true;
        const resp = await this.$http.loginTrue(paramsTrue);
        this.loginLoading = false;
        if (resp.status === 200) {
          localStorage.setItem('htmall_is_login', 1); // 保存登录态
          const userInfo = JSON.parse(resp.message.extra);
          this.storeInfo(userInfo);
          localStorage.setItem('portOrg', this.portOrg);
          localStorage.setItem('loginToken', resp.message.token);
          await this.$store.dispatch('getAuthcheckPermissionSets', Number(this.portOrg));
          this.judgeRouterPush(theUserIdentity, userInfo.orgId);
        } else {
          this.formInfo.code = '';
          this.getImageCodeFunc();
        }
      } else {
        if (res.status === 200 && res.message.sysAdminDTOList && res.message.sysAdminDTOList.length === 0) {
          this.$Message.error('没有对应的登录类型');
        }
        this.formInfo.code = '';
        this.getImageCodeFunc();
      }
    },
    // 登录接口
    async doLogin() {
      const params = {
        username: this.formInfo.username,
        password: this.formInfo.password,
        captcha: this.formInfo.code,
        captchaKey: this.captchaKey
      };
      this.loginLoading = true;
      const res = await this.$http.handelLoginNew(params);
      this.loginLoading = false;
      this.handleSetLoginInfo(res);
    },
    // ? 二次验证接口
    secondLogin() {
      this.secondary = false;
    },
    // 回填自动登录的信息
    fillLoginInfo() {
      const user = Cookies.get('u');
      const password = Cookies.get('p');
      if (user && password) {
        this.formInfo.username = decrypt(user);
        this.formInfo.password = decrypt(password);
      }
    },
    // 保存登录接口返回的信息到 localStorage 和 vuex
    storeInfo(info) {
      localStorage.setItem('userInfo', JSON.stringify(info));
      if (info.id != (localStorage.getItem('oldUserInfo') && JSON.parse(localStorage.getItem('oldUserInfo')) && JSON.parse(localStorage.getItem('oldUserInfo')).id)) {
        localStorage.removeItem('schoolSelectList');
        localStorage.removeItem('courseTableSch');
        localStorage.removeItem('schoolId');
        localStorage.removeItem('schoolName');
        localStorage.removeItem('refundSchoolSelectListOrg');
        localStorage.removeItem('refundSchoolSelectList');
        localStorage.removeItem('settlementSearch'); // 结算账单-主页 搜索条件
        localStorage.removeItem('430cacheSearch');
        this.udpateSettlementSearchByAction(null);
        this.updateSettlementDetailsSearch(null);
        this.CLOSE_BROWSINGHISTORYLIST('');
        this.SET_AUTH_MAP({});
      }
      this.$store.commit('SET_PORTORG', this.portOrg);
      this.$store.commit('SET_USERINFO', info);
    },
    // 获取验证码
    async getImageCodeFunc() {
      const res = await loginApi.getImageCodeNew();
      if (res.status === 200) {
        this.imgUrl = res.message.base64;
        this.captchaKey = res.message.captchaKey;
      }
    },
    // 判断要跳转到哪个首页
    judgeRouterPush(theUserIdentity, orgId = '') {
      switch (theUserIdentity) {
        case 'admin':
          // 平台
          this.$router.push({ name: 'operationIndex' });
          break;
        case 'edu':
          // 教育局
          console.log('跳转首页');
          if (orgId === '614867004922269697') {
            console.log('演示的');
            this.$router.push({ name: 'dataStatistics_dataStatistics' });
          } else {
            console.log('真实的');
            this.$router.push({ name: 'mainCenter_education_educationIndex' });
          }

          break;
        case 'school':
          // 学校
          this.$router.push({ name: 'schoolIndex' });
          break;
        case 'org':
          // 服务
          this.$router.push({ name: 'serviceIndex' });
          break;
        default:
          break;
      }
    },

    getCodeFunc() {
      if (this.codeText != '获取验证码') {
        return null;
      }
      this.$refs.formPhoneInfo.validateField('phone', res => {
        if (!res && this.formPhoneInfo.code !== '') {
          this.sendMsgToPcLogin();
        } else if (this.formPhoneInfo.code === '') {
          this.$Message.error('请输入图形验证码！');
        }
      });
    },
    // 发送短信验证码
    async sendMsgToPcLogin() {
      const res = await common.sendMsgToPcLogin({
        actCode: 'phoneLogin',
        phone: this.formPhoneInfo.phone,
        captcha: this.formPhoneInfo.code,
        captchaKey: this.captchaKey
      });
      if (res.status == 200) {
        let second = 60;
        this.codeText = `${second}s后获取`;
        // this.countDown = true;
        this.timer = setInterval(() => {
          if (second == 0) {
            clearInterval(this.timer);
            // this.countDown = false;
            this.codeText = '获取验证码';
            return false;
          }
          second--;
          this.codeText = `${second}s后获取`;
        }, 1000);
      } else if (res.status == 3101) {
        this.formPhoneInfo.code = '';
        this.getImageCodeFunc();
      }
    },
    // 短信登录
    async phoneCodeToPcLogin() {
      if (this.loginLoading) {
        return null;
      }
      this.loginLoading = true;
      const res = await common.phoneCodeToPcLogin({
        actCode: 'phoneLogin',
        phone: this.formPhoneInfo.phone,
        code: this.formPhoneInfo.msgCode
      });
      this.loginLoading = false;
      if (res.status == 200) {
        this.handleSetLoginInfo(res);
      } else {
        this.formPhoneInfo.msgCode = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  font-family: PingFangSC-Semibold, PingFang SC;
  display: flex;
  flex-direction: column;

  align-items: center;
  min-height: 100vh;
  box-sizing: border-box;
  /* background-color: #dee5ff;
  background-image: url('../../assets/img/login_bg.png'); */
  background-size: cover;
  background-position: center center;
  // background-repeat: no-repeat;
  background-image:url('../../assets/img/login/img_bg_login@2x.png');
  // padding-top: 80px;
  .login-top{
    width: 100%;
    height: 80px;
    // position: fixed;
    // top: 0;
    // left: 0;
    background-image:url('../../assets/img/login/img_mask_white@2x.png');
    .top-content{
      width: 1180px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .top-left{
        display: flex;
        align-items: center;
        img{
          width: 44px;
          height: 44px;
          margin-right: 10px;
        }
        span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 28px;
          text-align: left;
          font-style: normal;
        }
      }
      .top-right{
        display: flex;
        align-items: center;
        padding-right: 10px;
        img{
          width: 20px;
          height: 20px;
          margin-right: 6px;
        }
        a,span{
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 18px;
          text-align: center;
          font-style: normal;
        }
      }
    }
  }
  .login-content{
     width: 1180px;
     margin: 0 auto;
     display: flex;
     align-items: center;
     .content-left{
      width: 740px;
      height: 758px;
      flex-shrink: 0;
      img{
        width: 100%;
        height: 100%;
      }
     }
     .content-right {
      width:420px;
      height: 445px;
      box-sizing: border-box;
      .content-top{
        display: flex;
        align-items: center;
        width: 100%;
        height: 60px;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        .top-item{
          flex: 1;
          height: 100%;
          background: #EEF1F4;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #888888;
          line-height: 60px;
          text-align: center;
          font-style: normal;
        }
        .top-item-active{
          background: #fff;
          color:#222;
        }
      }
      .content-info{
        background: #fff;
        border-radius: 0 0 10px 10px;
        padding: 40px 43px 50px 43px;
        .username,
        .password,
        .phone,
        .msgCode,
        .code {
          border-bottom: 1px solid #dcdee2;
          input {
            height: 42px;
            font-size: 15px;
            flex: 1;
            // border: none;
          }
          /deep/.ivu-input{
            border: none;

          }
          .ivu-icon {
            line-height: 42px;
            // color: #1482ff;
          }
        }

        .code {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .img-code {
            margin-left: 10px;
            flex-shrink: 0;
            width: 95px;
            height: 28px;
            background-color: grey;
            .img100 {
              width: 100%;
              height: 100%;
            }
          }
          .msg-code {
            margin-left: 10px;
            flex-shrink: 0;
            text-align: center;
            line-height: 28px;
            border-radius: 6px;
            cursor: pointer;
            border: 1px solid #0077FF;
            font-size: 15px;
            color: #0077FF;
            line-height: 15px;
            text-align: left;
            font-style: normal;
            padding: 7px 10px;
          }
          .gray {
            // color: #999999;

            cursor: not-allowed;
          }
        }
      }
      .btn-block{
        margin-top: 40px;
        .btn{
          width: 100%;
          height: 46px;
          border-radius: 6px;
          /deep/span{
            font-weight: 600;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 16px;
            text-align: center;
            font-style: normal;
          }
        }
      }
      .agreement{
        text-align: center;
        margin-top: 21px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #444444;
        line-height: 14px;
        font-style: normal;
        // a{
        //   color: #0077FF;
        // }
        .document-dot{
          color: #0077FF;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
  .filings {
    // position: fixed;
    // bottom: 20px;
    // left: 50%;
    // transform: translateX(-50%);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    a {
      text-decoration: underline;
      color: #fff;
      margin-left: 5px;
    }
    // display: flex;
    .filings-bottom {
      margin-top: 10px;
    }
  }
}
</style>
